<template>
    <Container :padded="false" height="none" class="left-1/2 z-50 fixed -translate-x-1/2">
        <ul class="flex justify-between items-center gap-2 px-2 py-4">
            <li class="flex">
                <Drawer direction="right">
                    <DrawerTrigger>
                        <Glass blur="xs" padding="sm" class="cursor-pointer">
                            <Icon v-if="navigationMenu.icon" :name="navigationMenu.icon" class="size-8! text-primary" />
                        </Glass>
                    </DrawerTrigger>
                    <DrawerContent class="overflow-auto">
                        <DrawerHeader>
                            <DrawerTitle>
                                <Logo class="mx-auto max-w-16 md:max-w-36" />
                            </DrawerTitle>
                            <DrawerDescription>
                                <Typography variant="subtitle" class="text-center">
                                    {{ $t("general.navigationMenu.description") }}
                                </Typography>
                            </DrawerDescription>
                        </DrawerHeader>
                        <LayoutDefaultNavMenu :nav="navigationMenu.list" />

                        <DrawerFooter :dir="$dir.value" class="pb-12">
                            <div class="flex justify-between items-center">
                                <div class="flex items-center gap-2">
                                    <Icon :name="langSwitcher.icon ?? 'icon-park-outline:translate'" />
                                    <Typography>
                                        {{ $t(langSwitcher.title) }}
                                    </Typography>
                                </div>
                                <ToggleGroup variant="outline" type="multiple">
                                    <ToggleGroupItem
                                        v-for="(item, key) in langSwitcher.subItems"
                                        :key
                                        value="bold"
                                        :aria-label="`switch to: ${item.title}`"
                                    >
                                        <DrawerClose as-child>
                                            <NuxtLink :to="item.href" class="flex">
                                                <Icon :name="item.icon ?? 'majesticons:flag-line'" class="block" />
                                            </NuxtLink>
                                        </DrawerClose>
                                    </ToggleGroupItem>
                                </ToggleGroup>
                            </div>
                        </DrawerFooter>
                    </DrawerContent>
                </Drawer>
            </li>
            <li class="flex w-full">
                <WidgetSearch />
            </li>
        </ul>
    </Container>
</template>

<script lang="ts" setup>
import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
} from "@/components/ui/drawer";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Glass } from "@/components/ui/glass";

const { navigationMenu, langSwitcher } = useMenu();
</script>
